import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MarketingAutomationsManager } from "@/components/admin/MarketingAutomationsManager";

export const Route = createFileRoute("/admin/marketing/automacoes")({
  validateSearch: z.object({ criar: z.literal("automacao").optional() }),
  component: MarketingAutomationsManager,
});
